import { useAuth } from '../contexts/AuthContext';

/**
 * True when the signed-in user is an External (outside contractor) profile.
 *
 * Firestore rules refuse an External user every read except project-native
 * data, so any UI that reads another collection must skip the read (and hide
 * its panel) when this returns true. Staff (flag absent or false) are unaffected.
 */
export function useIsExternal(): boolean {
  // `?.` on useAuth(): the real hook always returns a context (it throws outside a
  // provider), but the global test mock (setupTests.ts) is a jest.fn that CRA's
  // resetMocks empties, so it returns undefined. Project list/detail hooks call this,
  // so every page test rendering them would crash without it.
  return useAuth()?.user?.isExternal === true;
}
